<template>
    <div>
        <header>
            <div>
                <img src="../../../assets/key/key-name-img.png" alt="">
                <strong>{{dataInfo.orgName}}</strong>
            </div>
            <div>{{dataInfo.status}}</div>
        </header>

        <main>
            <div class="main-item">
                <div class="main-item-name">房号</div>
                <div class="main-item-value">{{dataInfo.houseName}}</div>
            </div>
            <div class="main-item">
                <div class="main-item-name">租约有效期</div>
                <div class="main-item-value">{{getTime}}</div>
            </div>

            <div class="list-line"></div>

            <div class="main-item" v-for="data in getList" :key="data.id">
                <div class="main-item-name">{{data.name}}</div>
                <div class="main-item-value">￥{{parseInt(data.amount/100)}}/{{data.unit}}</div>
            </div>
        </main>

        <footer>
            <div class="footer-item" @click="openBack">退房</div>
            <div class="footer-item" v-if="dataInfo.rentalContractID&&(dataInfo.rentalContractState === '租客已签署'|| dataInfo.rentalContractState === '已完成')"
             @click="openLease(dataInfo)">查看合同</div>
             <div class="footer-item" v-else @click="openLease(dataInfo)">签署合同</div>
        </footer>

    </div>
</template>

<script>
    import utils from "../../Utils"
    import randomWord from "../../RandomWord"
    import axios from "axios";
    import wx from "weixin-js-sdk";
    import {Message} from 'element-ui';
    //import {MessageBox} from 'element-ui';

    export default {
        name: "ListItem",

        props: {
            dataInfo: {}
        },

        methods: {
            openLease(e) {
                console.log(e)
                if(!e.rentalContractID){
                    return Message.error("还未创建合同，请联系管家处理！");
                } 
                let vue = this;
                // 微信小程序 
                if ( this.dataInfo.rentalContractState === "租客已签署"|| this.dataInfo.rentalContractState === "已完成") { 
                    wx.miniProgram.getEnv(function() {
                        wx.miniProgram.navigateTo({
                            url: "/pages/lease/contract?"
                                + "leaseID=" + vue.dataInfo.id
                                + "&contractID=" + vue.dataInfo.rentalContractID
                                + "&orgID=" + vue.dataInfo.orgID
                        });
                    });

                }else {
                    wx.miniProgram.getEnv(function() {
                        wx.miniProgram.navigateTo({
                            url: "/pages/lease/confirm?"
                                + "leaseID=" + vue.dataInfo.id
                                 + "&contractID=" + vue.dataInfo.rentalContractID
                               + "&orgID=" + vue.dataInfo.orgID
                        });
                    });
                } 
            },

            openBack() {
                let vue = this;
                wx.miniProgram.getEnv(function() {
                    wx.miniProgram.navigateTo({
                        url: "/pages/lease/checkout?"
                            + "dataInfo=" + encodeURI(JSON.stringify(vue.dataInfo))
                    });
                });
            }
        },

        computed: {

            getTime() {
                return utils.long2IntervalDay(this.dataInfo.leaseStart * 1000, this.dataInfo.leaseEnd * 1000);
            },

            getList() {
                let list = [];
                if (this.dataInfo.Pricings) {
                    this.dataInfo.Pricings.forEach(item => {
                        item.id = randomWord.randomWord(false, 16);
                        list.push(item);
                    });
                }
                return list;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    .list-line {
        margin-top: 15px;
    }

    header {
        width: 90%;
        margin: 14px auto 0;
        border-radius: 10px;
        padding-left: 14px;
        padding-right: 14px;
        justify-content: space-between;
        align-items: center;
        color: white;
        box-sizing: border-box;
        background: $colorDefault;
        height: 44px;
        display: flex;
        img {
            height: 22px;
            width: 22px;
        }
        >div {
            align-items: center;
            display: flex;
            strong {
                margin-left: 5px;
            }
        }
    }

    main {
        font-size: 14px;
        padding: 14px;
        background: white;
        box-sizing: border-box;
        margin: auto;
        width: 90%;
        .main-item {
            margin-top: 10px;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            display: flex;
            .main-item-name {
                color: $fontColor-3;
            }
            .main-item-value {
                color: $fontColor-9;
            }
        }
    }

    footer {
        justify-content: space-between;
        display: flex;
        padding: 14px;
        box-sizing: border-box;
        background: #F7F7F7;
        width: 90%;
        margin: auto;
        .footer-item {
            text-align: center;
            color: white;
            width: 100px;
            line-height: 32px;
            background: $colorDefault;
            border-radius: 16px;
        }
    }

    .lease-container {
        top: 10%;
        iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
        height: 80%;
        right: 10%;
        width: 80%;
        position: fixed;
    }
</style>
